import React from "react";
import { Grid, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import ImageUploading from "react-images-uploading";

const BreakdownDescription = (props) => {
    const { t } = useTranslation();

    return (
        <>
            {/* BREAKDOWN DESCRIPTION(TEXT & SKETCHES) */}
            <Grid container xs={12} sm={12}>
                <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" sx={{ fontSize: 15, backgroundColor: "#DEE0E0" }}>
                        {t("BreakdownDescription(TextAndSketches)")}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <ImageUploading multiple={false} value={props.images} onChange={props.onChange} maxNumber={1} dataURLKey="data_url">
                        {({ imageList, onImageUpload, onImageRemoveAll, onImageUpdate, onImageRemove, isDragging, dragProps }) => (
                            // write your building UI
                            <div className="upload__image-wrapper">
                                <Button
                                    sx={{ display: props.fromPage === "list" || props.fromPage === "operator" ? "none" : "inline-block" }}
                                    style={isDragging ? { color: "red" } : undefined}
                                    onClick={onImageUpload}
                                    {...dragProps}
                                >
                                    {t("UploadFile")}
                                </Button>
                                &nbsp;
                                {/* <Button onClick={onImageRemoveAll} color="error">Remove All</Button> */}
                                {props.images && (
                                    <div className="image-item">
                                        <img src={props.images.length > 0 ? props.images[0]["data_url"] : props.images["data_url"]} alt="" width="600" />
                                        <div className="image-item__btn-wrapper">
                                            {props.images.length === 0 && props.fromPage === "list" && (
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end", minHeight: "250px" }}>
                                                    <img
                                                        style={{
                                                            animation: "spin 3s linear infinite",
                                                        }}
                                                        src={require("../../assets/logo.png")}
                                                        width="50"
                                                        alt="img"
                                                    />
                                                </div>
                                            )}
                                            <Button sx={{ display: props.fromPage === "list" || props.fromPage === "operator" ? "none" : "inline-block" }} onClick={props.handleRemoveAll}>
                                                {t("Delete")}
                                            </Button>
                                            {props.images.length === 0 && props.fromPage !== "operator" && props.fromPage !== "list" ? <p style={{ color: "red" }}>{t("EmptyCheck")}</p> : null}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </ImageUploading>
                </Grid>
            </Grid>
        </>
    );
};

export default BreakdownDescription;
